import { useEffect, useMemo, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatLocalDateTime } from "../../utils/formatDate";
import AvisoMotoristaService from "../../services/resource/avisoTelemetriaService";
import { reduzirNome } from "../../utils/reduzirNome";

function TabelaConcept({ data, ano, mes }) {

    const avisoMotoristaService = new AvisoMotoristaService();
    const [loading, setLoading] = useState(true);
    const [telemetrias, setTelemetrias] = useState([]);

    const values = {
        funcionarioId: data.funcionarioId,
        ano: ano,
        mes: mes
    }
    useEffect(() => {
        avisoMotoristaService.listar(values).then(res => {
            setTelemetrias(res.data);
        }).finally(() => setLoading(false))
    }, [])

    // meta da telemetria usada no cálculo (vem da comissão/snapshot; 98 só se não houver)
    const metaTelemetria = data.meta ?? 98;

    const formataIndice = (value) => {
        if (value >= metaTelemetria) {
            return <span className="font-bold text-teal-600">{value}</span>
        } else {
            return <span className="font-bold text-destructive">{value}</span>
        }
    }

    const medias = useMemo(() => {
        if (!telemetrias.length) {
            return {
                segurancaViaria: 0,
                manutencao: 0,
                performance: 0
            };
        }

        const soma = telemetrias.reduce((acc, item) => {
            acc.segurancaViaria += item.segurancaViaria || 0;
            acc.manutencao += item.manutencao || 0;
            acc.performance += item.performance || 0;
            return acc;
        }, {
            segurancaViaria: 0,
            manutencao: 0,
            performance: 0
        });

        return {
            segurancaViaria: (soma.segurancaViaria / telemetrias.length).toFixed(2),
            manutencao: (soma.manutencao / telemetrias.length).toFixed(2),
            performance: (soma.performance / telemetrias.length).toFixed(2)
        };
    }, [telemetrias]);

    return (
        <div>
            <DataTable
                value={telemetrias}
                loading={loading}
                scrollable
                scrollHeight="450px"
                dataKey="id"
                size="small"
                className="text-[12px] custom-datatable text-foreground border border-border cursor-default"
                rowClassName="text-[12px] border-b border-border min-w-[400px] text-foreground cursor-default"
                Menu={false}
                emptyMessage="Nenhuma carga encontrada."
                footer={() => (
                    <div className="flex justify-between items-center p-2 font-semibold text-[12px]">
                        <div>
                            Total de Avisos: {telemetrias.length}
                        </div>
                    </div>
                )}
            >

                <Column
                    field="funcionarioNome"
                    header="Funcionario"
                    sortable
                    body={(item) => reduzirNome(item.funcionarioNome)}
                    Menu={false}
                    className="px-3"
                    style={{ minWidth: "140px" }}
                />

                <Column
                    field="dataHora"
                    header="Data"
                    sortable
                    body={row => formatLocalDateTime(row.dataHora)}
                    Menu={false}
                    className="px-3"
                    style={{ minWidth: "140px" }}
                />

                <Column
                    field="descricao"
                    header="Descrição"
                    sortable
                    style={{ minWidth: "240px" }}
                />

                <Column
                    field="tipo"
                    header="Descrição"
                    sortable
                    style={{ minWidth: "240px" }}
                />

                <Column
                    field="velocidadeVia"
                    header="Vel. Via"
                    sortable
                />

                <Column
                    field="velocidadeVeiculo"
                    header="Vel. Veic"
                    sortable
                />

                <Column
                    field="percentualVelocidade"
                    header="%"
                    body={item => <label className={item.percentualVelocidade > 105 ? 'text-destructive font-semibold' : ''}>{item.percentualVelocidade}%</label>}
                    sortable
                />


            </DataTable>
        </div>
    );
}

export default TabelaConcept;